/** tempexp_19786-start */

import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

/** Отключает скролл в окне отключения рекламы в почте */
export const tariffModalDisableScroll = isFeature('tariff-modal-disable-scroll');

/** Период debounce изменения размера окна отключения рекламы в почте */
export const disableAdsModalResizeWait: number = getFeature('disable-ads-modal-resize-wait') || 0;

/** tempexp_19786-end */
